import React from 'react'
import { Form, Row, Col } from 'reactstrap'
import { localized } from 'decorators'
import { DialogBase, dialogSizes } from 'dialogs/dialogBase'
import { LoadingContent } from 'dialogs'

export class LoadingDialog extends DialogBase {
  modalTitle() { return this.props.title || super.modalTitle() }
  modalSize () { return this.props.modalSize || dialogSizes.LG }
  modalButtons () { return null }
  modalBody () {
    return (
      <Form>
        <Row>
          <Col sm='12'>
            <LoadingContent />
          </Col>
        </Row>
      </Form>
    )
  }
}

export default localized(LoadingDialog)
